import { parseHostname } from "shared";

/**
 * Helper for pulling a space-identifying domain from the URL.
 */

export default function getCustomDomainComponents(
  hostname?: string
): ReturnType<typeof parseHostname> {
  const host = hostname || (typeof window !== "undefined" ? window.location.hostname : "localhost");
  return parseHostname(host);
}
